import _get from 'lodash/get';

import { Google, GoogleTransformers, Pixall, PixallTransformers } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;

const { inventoryTransformer: PixallInventoryTransformer } = PixallTransformers;
/**
 * @summary Sends Google and Pixall impressions for additional protections info on vdp
 */
export function inventoryAdditionalProtectionsImpression(metadata, option) {
    const {
        data = {},
        dataLayer = {},
        state,
        history,
    } = metadata;

    const { inventoryId } = data;
    const pageName = _get(dataLayer, 'page.pageName', '');
    const inheritPageData = !['vdp'].includes(pageName);
    const inventory = getInventoryOwnerById(state, inventoryId);
    const vehicleData = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer }, inheritPageData);
    const eventData = {
        vehicle: { ...vehicleData },
    };

    const element = `vdp_${data?.listingType.toLowerCase()}`;
    const cmp = 'cta::view-more-information::additional-protections';

    Google.sendImpressions(metadata, {
        eventElement: element,
        eventResult: cmp,
        eventData,
    }, option);

    Pixall.sendImpression({ dataLayer, history }, {
        clickType: inventory?.clickType,
        eventSource: 'application',
        label: cmp,
        ...PixallInventoryTransformer.getInventoryData(inventory),
    }, option);

    return { cmp, element };
}
